import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Installation } from 'src/app/model/installation/installation.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';

@Component({
  selector: 'app-installation-properties',
  templateUrl: './installation-properties.component.html',
  styleUrls: ['./installation-properties.component.scss']
})
export class InstallationPropertiesComponent implements OnInit {

  @Input() installation !: any;

  constructor(private service: InstallationsService, private activatedRoute: ActivatedRoute) {}

  public champ: string[] = [];
  public keys !: any;
  public tJour = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];
  public tMois = [ "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

  ngOnInit(): void {

    if (this.installation) {
      let key = Object.keys(this.installation.champs);
      for (let i = 0; i < key.length; i++) {
        this.champ.push(key[i]);
      }
    }
  }

  getValeurChamp(nomChamp: string) {
    for (let i = 0; i < this.keys.length; i++) {
      if (nomChamp === this.keys[i]) return this.keys[i].valeur_champ;
    }
  }

      /**
   * Display date into human format
   */
       public convertDate( date : string ) : string {

        let newDate = Date.parse( date );
        let correctDate = new Date( newDate );
        let result = this.tJour[correctDate.getDay() - 1] + ' ' +  correctDate.getDate() + ' ' +  this.tMois[(correctDate.getMonth())] + ' ' + correctDate.getFullYear() + ' à ' + correctDate.getHours() + ':' + this.getCorrectMinuteDisplay(correctDate);
        return result;
        
      }
  
      
    /**Enhance minutes display */
    public getCorrectMinuteDisplay( date : Date ) : any {
      if ( date.getMinutes() < 10 ) return '0' + date.getMinutes();
      else return date.getMinutes();
    }
  

}
